/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Bank API Service
 * API для работы с банками России - коды, названия, иконки
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { banksKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type BankCreate,
    type BankListResponse,
    type BankResponse,
    type BankUpdate,
    type GetBanksApiV1BanksGetParams,
    type HTTPValidationError,
    type MessageResponse,
    type PopularBanksUpdate,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') {
            continue;
        }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getGetBanksApiV1BanksGetUrl = (params?: GetBanksApiV1BanksGetParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/api/v1/banks?${stringifiedParams}` : '/api/v1/banks';
};

/**
 * Получить список всех банков с пагинацией
 *
 * - **skip**: количество пропускаемых записей (offset)
 * - **limit**: максимальное количество записей в ответе
 * - **popular_only**: если True, вернет только популярные банки
 * - **search**: поиск по названию банка (RU/EN)
 * @summary Get Banks
 */
export const getBanksApiV1BanksGet = async (
    params?: GetBanksApiV1BanksGetParams,
    options?: RequestInit,
): Promise<BankListResponse> => {
    return banksKyMutator<BankListResponse>(getGetBanksApiV1BanksGetUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetBanksApiV1BanksGetQueryKey = (params?: GetBanksApiV1BanksGetParams) => {
    return ['/api/v1/banks', ...(params ? [params] : [])] as const;
};

export const getGetBanksApiV1BanksGetQueryOptions = <
    TData = Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    params?: GetBanksApiV1BanksGetParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBanksApiV1BanksGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBanksApiV1BanksGetQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBanksApiV1BanksGet>>> = ({ signal }) =>
        getBanksApiV1BanksGet(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBanksApiV1BanksGetQueryResult = NonNullable<Awaited<ReturnType<typeof getBanksApiV1BanksGet>>>;
export type GetBanksApiV1BanksGetQueryError = ErrorType<HTTPValidationError>;

export function useGetBanksApiV1BanksGet<
    TData = Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    params: undefined | GetBanksApiV1BanksGetParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBanksApiV1BanksGet>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
                    TError,
                    Awaited<ReturnType<typeof getBanksApiV1BanksGet>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBanksApiV1BanksGet<
    TData = Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    params?: GetBanksApiV1BanksGetParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBanksApiV1BanksGet>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
                    TError,
                    Awaited<ReturnType<typeof getBanksApiV1BanksGet>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBanksApiV1BanksGet<
    TData = Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    params?: GetBanksApiV1BanksGetParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBanksApiV1BanksGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Banks
 */

export function useGetBanksApiV1BanksGet<
    TData = Awaited<ReturnType<typeof getBanksApiV1BanksGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    params?: GetBanksApiV1BanksGetParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBanksApiV1BanksGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetBanksApiV1BanksGetQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateBankApiV1BanksPostUrl = () => {
    return '/api/v1/banks';
};

/**
 * Добавить новый банк (Требуется API ключ)
 *
 * - **code**: уникальный код банка
 * - **name_ru**: название на русском
 * - **name_en**: название на английском
 * - **short_name**: короткое имя (опционально)
 * - **is_popular**: популярный банк (по умолчанию False)
 * - **sort_order**: порядок сортировки (по умолчанию 0)
 * - **bank_member_id**: ID участника НСПК/Tinkoff (опционально)
 * @summary Create Bank
 */
export const createBankApiV1BanksPost = async (
    bankCreate: BankCreate,
    options?: RequestInit,
): Promise<BankResponse> => {
    return banksKyMutator<BankResponse>(getCreateBankApiV1BanksPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(bankCreate),
    });
};

export const getCreateBankApiV1BanksPostQueryKey = (bankCreate?: BodyType<BankCreate>) => {
    return ['POST', '/api/v1/banks', bankCreate] as const;
};

export const getCreateBankApiV1BanksPostQueryOptions = <
    TData = Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    bankCreate: BodyType<BankCreate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createBankApiV1BanksPost>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getCreateBankApiV1BanksPostQueryKey(bankCreate);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof createBankApiV1BanksPost>>> = ({ signal }) =>
        createBankApiV1BanksPost(bankCreate, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateBankApiV1BanksPostQueryResult = NonNullable<Awaited<ReturnType<typeof createBankApiV1BanksPost>>>;
export type CreateBankApiV1BanksPostQueryError = ErrorType<HTTPValidationError>;

export function useCreateBankApiV1BanksPost<
    TData = Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    bankCreate: BodyType<BankCreate>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof createBankApiV1BanksPost>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
                    TError,
                    Awaited<ReturnType<typeof createBankApiV1BanksPost>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateBankApiV1BanksPost<
    TData = Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    bankCreate: BodyType<BankCreate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createBankApiV1BanksPost>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
                    TError,
                    Awaited<ReturnType<typeof createBankApiV1BanksPost>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateBankApiV1BanksPost<
    TData = Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    bankCreate: BodyType<BankCreate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createBankApiV1BanksPost>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create Bank
 */

export function useCreateBankApiV1BanksPost<
    TData = Awaited<ReturnType<typeof createBankApiV1BanksPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    bankCreate: BodyType<BankCreate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createBankApiV1BanksPost>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getCreateBankApiV1BanksPostQueryOptions(bankCreate, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getSetPopularBanksApiV1BanksPopularPostUrl = () => {
    return '/api/v1/banks/popular';
};

/**
 * Установить популярные банки (Требуется API ключ)
 *
 * Все банки из списка будут отмечены как популярные,
 * остальные банки будут сняты с популярных.
 *
 * - **bank_codes**: список кодов банков для отметки как популярные
 * @summary Set Popular Banks
 */
export const setPopularBanksApiV1BanksPopularPost = async (
    popularBanksUpdate: PopularBanksUpdate,
    options?: RequestInit,
): Promise<MessageResponse> => {
    return banksKyMutator<MessageResponse>(getSetPopularBanksApiV1BanksPopularPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(popularBanksUpdate),
    });
};

export const getSetPopularBanksApiV1BanksPopularPostQueryKey = (popularBanksUpdate?: BodyType<PopularBanksUpdate>) => {
    return ['POST', '/api/v1/banks/popular', popularBanksUpdate] as const;
};

export const getSetPopularBanksApiV1BanksPopularPostQueryOptions = <
    TData = Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    popularBanksUpdate: BodyType<PopularBanksUpdate>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>, TError, TData>
        >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSetPopularBanksApiV1BanksPopularPostQueryKey(popularBanksUpdate);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>> = ({ signal }) =>
        setPopularBanksApiV1BanksPopularPost(popularBanksUpdate, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SetPopularBanksApiV1BanksPopularPostQueryResult = NonNullable<
    Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>
>;
export type SetPopularBanksApiV1BanksPopularPostQueryError = ErrorType<HTTPValidationError>;

export function useSetPopularBanksApiV1BanksPopularPost<
    TData = Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    popularBanksUpdate: BodyType<PopularBanksUpdate>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
                    TError,
                    Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSetPopularBanksApiV1BanksPopularPost<
    TData = Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    popularBanksUpdate: BodyType<PopularBanksUpdate>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
                    TError,
                    Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSetPopularBanksApiV1BanksPopularPost<
    TData = Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    popularBanksUpdate: BodyType<PopularBanksUpdate>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>, TError, TData>
        >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Set Popular Banks
 */

export function useSetPopularBanksApiV1BanksPopularPost<
    TData = Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>,
    TError = ErrorType<HTTPValidationError>,
>(
    popularBanksUpdate: BodyType<PopularBanksUpdate>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof setPopularBanksApiV1BanksPopularPost>>, TError, TData>
        >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getSetPopularBanksApiV1BanksPopularPostQueryOptions(popularBanksUpdate, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetBankLogoApiV1BanksCodeLogoGetUrl = (code: string) => {
    return `/api/v1/banks/${code}/logo`;
};

/**
 * Получить содержимое логотипа банка (Прокси).
 *
 * Сначала определяет работающий URL (НСПК или Tinkoff),
 * затем скачивает и отдает содержимое изображения.
 * @summary Get Bank Logo
 */
export const getBankLogoApiV1BanksCodeLogoGet = async (code: string, options?: RequestInit): Promise<unknown> => {
    return banksKyMutator<unknown>(getGetBankLogoApiV1BanksCodeLogoGetUrl(code), {
        ...options,
        method: 'GET',
    });
};

export const getGetBankLogoApiV1BanksCodeLogoGetQueryKey = (code: string) => {
    return [`/api/v1/banks/${code}/logo`] as const;
};

export const getGetBankLogoApiV1BanksCodeLogoGetQueryOptions = <
    TData = Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBankLogoApiV1BanksCodeLogoGetQueryKey(code);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>> = ({ signal }) =>
        getBankLogoApiV1BanksCodeLogoGet(code, { signal, ...requestOptions });

    return { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBankLogoApiV1BanksCodeLogoGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>
>;
export type GetBankLogoApiV1BanksCodeLogoGetQueryError = ErrorType<HTTPValidationError>;

export function useGetBankLogoApiV1BanksCodeLogoGet<
    TData = Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
                    TError,
                    Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBankLogoApiV1BanksCodeLogoGet<
    TData = Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
                    TError,
                    Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBankLogoApiV1BanksCodeLogoGet<
    TData = Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Bank Logo
 */

export function useGetBankLogoApiV1BanksCodeLogoGet<
    TData = Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankLogoApiV1BanksCodeLogoGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetBankLogoApiV1BanksCodeLogoGetQueryOptions(code, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetBankApiV1BanksCodeGetUrl = (code: string) => {
    return `/api/v1/banks/${code}`;
};

/**
 * Получить банк по коду
 *
 * - **code**: уникальный код банка (например, 100000000001)
 * @summary Get Bank
 */
export const getBankApiV1BanksCodeGet = async (code: string, options?: RequestInit): Promise<BankResponse> => {
    return banksKyMutator<BankResponse>(getGetBankApiV1BanksCodeGetUrl(code), {
        ...options,
        method: 'GET',
    });
};

export const getGetBankApiV1BanksCodeGetQueryKey = (code: string) => {
    return [`/api/v1/banks/${code}`] as const;
};

export const getGetBankApiV1BanksCodeGetQueryOptions = <
    TData = Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBankApiV1BanksCodeGetQueryKey(code);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>> = ({ signal }) =>
        getBankApiV1BanksCodeGet(code, { signal, ...requestOptions });

    return { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBankApiV1BanksCodeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>>;
export type GetBankApiV1BanksCodeGetQueryError = ErrorType<HTTPValidationError>;

export function useGetBankApiV1BanksCodeGet<
    TData = Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
                    TError,
                    Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBankApiV1BanksCodeGet<
    TData = Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
                    TError,
                    Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBankApiV1BanksCodeGet<
    TData = Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Bank
 */

export function useGetBankApiV1BanksCodeGet<
    TData = Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankApiV1BanksCodeGet>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetBankApiV1BanksCodeGetQueryOptions(code, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateBankApiV1BanksCodePatchUrl = (code: string) => {
    return `/api/v1/banks/${code}`;
};

/**
 * Обновить данные банка (Требуется API ключ)
 *
 * - **code**: код банка для обновления
 * - Все поля опциональны, обновятся только переданные
 * @summary Update Bank
 */
export const updateBankApiV1BanksCodePatch = async (
    code: string,
    bankUpdate: BankUpdate,
    options?: RequestInit,
): Promise<BankResponse> => {
    return banksKyMutator<BankResponse>(getUpdateBankApiV1BanksCodePatchUrl(code), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(bankUpdate),
    });
};

export const getUpdateBankApiV1BanksCodePatchQueryKey = (code: string, bankUpdate?: BodyType<BankUpdate>) => {
    return ['PATCH', `/api/v1/banks/${code}`, bankUpdate] as const;
};

export const getUpdateBankApiV1BanksCodePatchQueryOptions = <
    TData = Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    bankUpdate: BodyType<BankUpdate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getUpdateBankApiV1BanksCodePatchQueryKey(code, bankUpdate);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>> = ({ signal }) =>
        updateBankApiV1BanksCodePatch(code, bankUpdate, { signal, ...requestOptions });

    return { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UpdateBankApiV1BanksCodePatchQueryResult = NonNullable<
    Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>
>;
export type UpdateBankApiV1BanksCodePatchQueryError = ErrorType<HTTPValidationError>;

export function useUpdateBankApiV1BanksCodePatch<
    TData = Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    bankUpdate: BodyType<BankUpdate>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
                    TError,
                    Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateBankApiV1BanksCodePatch<
    TData = Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    bankUpdate: BodyType<BankUpdate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
                    TError,
                    Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateBankApiV1BanksCodePatch<
    TData = Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    bankUpdate: BodyType<BankUpdate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update Bank
 */

export function useUpdateBankApiV1BanksCodePatch<
    TData = Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    bankUpdate: BodyType<BankUpdate>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateBankApiV1BanksCodePatch>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getUpdateBankApiV1BanksCodePatchQueryOptions(code, bankUpdate, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteBankApiV1BanksCodeDeleteUrl = (code: string) => {
    return `/api/v1/banks/${code}`;
};

/**
 * Удалить банк (Требуется API ключ)
 *
 * - **code**: код банка для удаления
 * @summary Delete Bank
 */
export const deleteBankApiV1BanksCodeDelete = async (code: string, options?: RequestInit): Promise<MessageResponse> => {
    return banksKyMutator<MessageResponse>(getDeleteBankApiV1BanksCodeDeleteUrl(code), {
        ...options,
        method: 'DELETE',
    });
};

export const getDeleteBankApiV1BanksCodeDeleteQueryKey = (code: string) => {
    return ['DELETE', `/api/v1/banks/${code}`] as const;
};

export const getDeleteBankApiV1BanksCodeDeleteQueryOptions = <
    TData = Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getDeleteBankApiV1BanksCodeDeleteQueryKey(code);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>> = ({ signal }) =>
        deleteBankApiV1BanksCodeDelete(code, { signal, ...requestOptions });

    return { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeleteBankApiV1BanksCodeDeleteQueryResult = NonNullable<
    Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>
>;
export type DeleteBankApiV1BanksCodeDeleteQueryError = ErrorType<HTTPValidationError>;

export function useDeleteBankApiV1BanksCodeDelete<
    TData = Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
                    TError,
                    Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteBankApiV1BanksCodeDelete<
    TData = Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
                    TError,
                    Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteBankApiV1BanksCodeDelete<
    TData = Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete Bank
 */

export function useDeleteBankApiV1BanksCodeDelete<
    TData = Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>,
    TError = ErrorType<HTTPValidationError>,
>(
    code: string,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteBankApiV1BanksCodeDelete>>, TError, TData>>;
        request?: SecondParameter<typeof banksKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getDeleteBankApiV1BanksCodeDeleteQueryOptions(code, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
